import cn from "classnames";
import { Icon } from "semantic-ui-react";
import NoResults from "../../../../components/noResults/NoResults";
import NoSearchResults from "../../../../components/noSearchResults";
import styles from "./videosAssetsNoResults.module.scss";

export interface Props {
  filtered: boolean;
  createAssetButton?: React.ReactNode;
  title?: string;
  description?: string;
}

export const VideoAssetsNoResults: React.FC<Props> = ({ filtered, createAssetButton, title, description }) => {
  const defaultDescription = createAssetButton
    ? "Looks like you don't have any videos for this group. Add some using the button below."
    : "Looks like you don't have any videos for this group.";
  const descriptionMarkup = description || defaultDescription;
  return filtered ? (
    <NoSearchResults />
  ) : (
    <NoResults
      title={title || "You don't have any videos"}
      description={descriptionMarkup}
      icon={<Icon className={cn("fa-video", styles.videoIcon)} />}
    >
      {createAssetButton}
    </NoResults>
  );
};
